module.exports = "<div md-whiteframe=\"1\" class=\"content-box text-center\">\n    <h1>{{ \"USERS.CLIENT_REGISTRATION_CONFIRM.GREETINGS\" | translate:{name: userName} }}</h1>\n    <p>{{ \"USERS.CLIENT_REGISTRATION_CONFIRM.INFO\" | translate }}</p> \n  </div>";


//////////////////
// WEBPACK FOOTER
// ./src/users/client/client-registration-confirm.html
// module id = 237
// module chunks = 0